'use client';

import { useState } from 'react';
import Link from 'next/link';
import { ArrowRight, Store } from 'lucide-react';

export function BusinessSlugFinder() {
    const [slug, setSlug] = useState('');
    const trimmed = slug.trim().toLowerCase().replace(/\s+/g, '-');
    const hasSlug = trimmed.length > 2;

    return (
        <div className="rounded-2xl border border-violet-100 bg-violet-50/60 p-5 space-y-4">
            <div className="flex items-start gap-3">
                <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-violet-500/15 text-violet-600">
                    <Store className="h-4 w-4" />
                </div>
                <div>
                    <p className="text-sm font-semibold text-slate-800">Staff or customer portal</p>
                    <p className="mt-0.5 text-xs leading-5 text-slate-500">
                        Each business has its own portal. Enter the business slug or use the link your manager shared.
                    </p>
                </div>
            </div>

            <input
                type="text"
                placeholder="business-slug"
                value={slug}
                onChange={(e) => setSlug(e.target.value)}
                className="h-11 w-full rounded-xl border border-violet-200 bg-white px-3.5 text-sm font-mono text-slate-950 placeholder:text-slate-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-500/40"
            />

            {hasSlug && (
                <div className="flex flex-col gap-2">
                    <Link
                        href={`/portal/${trimmed}/staff/login`}
                        className="group flex items-center justify-between rounded-xl border border-violet-200 bg-white px-3.5 py-2.5 text-sm no-underline transition-colors hover:border-violet-400 hover:bg-violet-100/60"
                    >
                        <span className="font-medium text-slate-800">Staff login</span>
                        <span className="flex items-center gap-1 font-mono text-[11px] text-violet-700">
              /portal/{trimmed}/staff/login
              <ArrowRight className="h-3 w-3 transition-transform group-hover:translate-x-0.5" />
            </span>
                    </Link>
                    <Link
                        href={`/portal/${trimmed}/customer/login`}
                        className="group flex items-center justify-between rounded-xl border border-violet-200 bg-white px-3.5 py-2.5 text-sm no-underline transition-colors hover:border-violet-400 hover:bg-violet-100/60"
                    >
                        <span className="font-medium text-slate-800">Customer login</span>
                        <span className="flex items-center gap-1 font-mono text-[11px] text-violet-700">
              /portal/{trimmed}/customer/login
              <ArrowRight className="h-3 w-3 transition-transform group-hover:translate-x-0.5" />
            </span>
                    </Link>
                </div>
            )}

            <p className="text-[11px] leading-5 text-slate-500">
                The slug is in the URL your manager or business sent you. Example: if the link is{' '}
                <span className="rounded bg-white px-1 py-0.5 font-mono text-violet-700">bizpos.lk/portal/food-city-ab12/staff/login</span>, the slug is{' '}
                <span className="rounded bg-white px-1 py-0.5 font-mono text-violet-700">food-city-ab12</span>.
            </p>
        </div>
    );
}